import getApiLayer from 'lib/api/getApiLayer';
import { API_BASEURL } from 'lib/urls';

import authInterceptor from './interceptors/authInterceptor';
import statusErrorInterceptor from './interceptors/statusErrorInterceptor';
import { insertCsrfToken } from './interceptors/userInterceptor';

const { abort, setEndpoint } = getApiLayer({
  baseUrl: `${API_BASEURL}`,
  contentType: 'application/json; charset=UTF-8',
  retryTimes: 0,
  // Rack::Attack meters the monolith per user id per path, so an ordinary page
  // that fans several requests at one endpoint can be throttled on a single
  // interaction. Without this, statusErrorInterceptor flattens the 429 into a
  // generic "HTTP Error 429" and the call site fails with nothing useful to show.
  // Three replays, honouring Retry-After when the server sends one.
  rateLimitRetryDelaysMs: [500, 1500, 4000],
  interceptor: {
    before: [insertCsrfToken],
    after: [statusErrorInterceptor, authInterceptor],
    errorHandler: [authInterceptor],
  },
});

export { abort, setEndpoint };
